import React from 'react';
import PropTypes from 'prop-types';

// Shared
import FeaturedServicesCard from '@cards/FeaturedServicesCard';
import LoadingArea from '@molecules/LoadingArea';
import { H4, BodyLarge, DivWithShadowAlternate } from '@styled';
import Search from '../../searches/Search';
import SearchResults from '../../searches/Search/SearchResults';
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';

// Functionality
import { SAVED_CONTACTS_RECORD_ID_QUERY } from '@general/graphql/contact.graph';
import useCompanyFull from '@hooks/useCompanyFull';
import useCompanyProfileFeaturedServicesFilterString from './hooks/useCompanyProfileFeaturedServicesFilterString';
import useViewer from '@hooks/useViewer';
import { mapAlgoliaContactWithSavedSearchesToProps } from '@general/transforms/member.transform';

function CompanyProfileFeaturedServices({ graphID }) {
    const { data: companyData, loading } = useCompanyFull(graphID);
    const { viewer, loading: loadingViewer } = useViewer();
    const servicesFilterString = useCompanyProfileFeaturedServicesFilterString({
        company: companyData,
        viewer,
    });

    if (!companyData || !servicesFilterString) {
        return null;
    }

    if (loading || loadingViewer) {
        return <LoadingArea />;
    }

    const algoliaIndex = 'saved_searchable_members_non_distinct';

    return (
        <div className="col-lg-12 mt-4">
            <H4 className="mb-1.5rem">Featured Services</H4>
            <DivWithShadowAlternate className="pl-4 pr-4 pt-4" style={{ width: '100%' }}>
                <BodyLarge className="mb-1.5rem">{companyData.name} has defined the following services:</BodyLarge>
                <SearchModeContext.Provider value={{ showFilters: false }}>
                    <Search
                        filters={servicesFilterString}
                        index={algoliaIndex}
                        defaultViewType="card"
                        displayPagingToolbar
                        displaySearchBox={false}
                        displaySearchOptions={false}
                        hitsPerPage={4}
                        maxWidth="auto"
                    >
                        <SearchResults
                            cardComponent={FeaturedServicesCard}
                            listItemComponent={FeaturedServicesCard}
                            index={algoliaIndex}
                            query={SAVED_CONTACTS_RECORD_ID_QUERY}
                            transformFunc={mapAlgoliaContactWithSavedSearchesToProps}
                            typePlural="contacts"
                            resultsPerRow={2}
                            NoResultsText={() => (
                                <>There are no matching services for members related to this company.</>
                            )}
                        />
                    </Search>
                </SearchModeContext.Provider>
            </DivWithShadowAlternate>
        </div>
    );
}

CompanyProfileFeaturedServices.propTypes = {
    graphID: PropTypes.string,
};

export default CompanyProfileFeaturedServices;
